/** Query keys for the sector taxonomy reference data (MYN-46, startup-only for now). */
export const TAXONOMY_KEYS = {
  sectors: ['taxonomy', 'sectors'] as const,
};
